<template>
  <label
    class="aha-checkbox inline-flex items-center"
    :for="id"
    @click.stop
    :class="{'disabled': disabled}"
  >
    <input
      type="checkbox"
      class="checkbox-component-input"
      :id="id"
      :checked="checked"
      :disabled="disabled"
      @change="$emit('change', $event.target.checked)"
    >
    <span
      class="checkbox-component-wrapper"
      :class="{
        '--disabled': disabled,
        'mr-2': $slots.default,
      }"
    >
      <aha-icon
        class="checkbox-component-checkbox"
        name="check"
        viewBox="0 0 24 24"
        width="12"
        height="12"
      />
    </span>
    <slot />
  </label>
</template>

<script>
import AhaIcon from './Icon.vue'

export default {
  components: {
    AhaIcon,
  },
  model: {
    prop: 'checked',
    event: 'change',
  },
  props: {
    id: {
      type: String,
      default: () => {
        return Math.random().toString().substring(7)
      },
    },
    checked: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
.aha-checkbox:not(.disabled) {
  @apply cursor-pointer;
}
.checkbox-component-input {
  @apply hidden;
}

.checkbox-component-checkbox {
  @apply absolute top-0 left-0 text-base-0 hidden;
}

.checkbox-component-wrapper {
  @apply relative border-secondary-40 border bg-base-0;
  @apply inline-block h-3.5 rounded w-3.5 flex-shrink-0;

  &.--disabled {
    @apply cursor-not-allowed;
  }
}

.checkbox-component-input:checked {
  + .checkbox-component-wrapper {
    @apply bg-secondary-50 border-transparent;
  }

  + .checkbox-component-wrapper .checkbox-component-checkbox {
    @apply inline-block;
  }
}

</style>
